import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, combineReducers } from 'redux'
import storage from 'store2'
import API, { configure } from '../api'
import moment from 'moment'
import { Provider } from 'react-redux'
import { IntlProvider, addLocaleData } from 'react-intl'
import { numberOfTrips } from '../actions/search-actions'
import { selectedCurrency, pageLoader, itineraryPopupOpen, itineraryPopupData } from '../actions/main-actions'
import { headerDirective, smoothScroll, mobileHeader, stickyNavigation, wishlistDirective, copyAffiliateLink, shareAffiliate, hideTopBanner, headerDestinationToggle, changeAffiliateDirective } from '../directives'
// import * as fx from '../libs/money'
import HeaderTypeahead from '../components/header/HeaderTypeahead'
import HeaderSearchSection from '../components/header/HeaderSearchSection'
import { getLanguage, getToken, getCookie, removeToken, setAffiliateCookie } from '../utils'
import { toast } from 'react-toastify'
import 'babel-polyfill'
import 'whatwg-fetch'
import 'react-toastify/dist/ReactToastify.css'

import en from 'react-intl/locale-data/en.js'
import fr from 'react-intl/locale-data/fr.js'
import de from 'react-intl/locale-data/de.js'
import it from 'react-intl/locale-data/it.js'
import es from 'react-intl/locale-data/es.js'
import IndividualBooking from '../components/footer/IndividualBooking'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: ['AbortError', 'UnhandledRejection', 'Unexpected token o in JSON at position 1', 'Anonymous function(/gtm.js)'],
  })
}

if(getCookie('logout') === 'True') {
  removeToken()
}
const token = getToken()

// Previous search handle
const previousSearch = storage('previousSearch')

if(previousSearch && token) {
  previousSearch.forEach(function(searchData) {
    API(`account/search-requests/`, false, true).post({
      searchData,
    })
  })
  storage.remove('previousSearch')
}

// Token refresh
const loginDate = storage('login_date')
if(token && loginDate && moment().diff(loginDate, 'days') >= 1) {
  API('account/token-refresh/').post({
    token,
  }).then(function(data) {
    if(data.token) {
      storage.set('token', data.token)
      storage.set('login_date', moment().format('YYYY-MM-DD'))
    }
  })
}

setAffiliateCookie()
addLocaleData([...en, ...fr, ...de, ...it, ...es])

let store = createStore(combineReducers({
  pageLoader,
  numberOfTrips,
  selectedCurrency,
  itineraryPopupOpen,
  itineraryPopupData,
}))

let language = getLanguage()
let messages = {}
toast.configure()

window.store = store
configure(store)

// window.fx = fx

if(language !== 'en') {
  Promise.all([
    window.fetch(window.staticPath + `travel-app/dist/translations/travel-${language}.json`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      } }),
  ]).then(function([ response ]) {
    response.json().then((msg) => {
      messages = msg[`travel-${language}`]

      renderApp()
    })
  })
} else {
  renderApp()
}

function renderApp() {
  const intlProvider = new IntlProvider({ locale: language, messages })
  const { intl } = intlProvider.getChildContext()

  renderElement('typeahead-react', HeaderTypeahead)
  renderElement('react-header-search', HeaderSearchSection)
  renderElement('header-email-us', IndividualBooking)
  headerDirective()
  mobileHeader()
  stickyNavigation()
  wishlistDirective(intl)
  copyAffiliateLink()
  shareAffiliate()
  hideTopBanner()
  smoothScroll()
  headerDestinationToggle()
  changeAffiliateDirective()
}

function renderElement(id, ComponentToRender, props) {
  const element = document.getElementById(id)

  if(element) {
    ReactDOM.render(
      <IntlProvider locale={language === 'ach' ? 'en' : language} messages={messages}>
        <Provider store={window.store}>
          <ComponentToRender {...props} />
        </Provider>
      </IntlProvider>,
      element
    )
  }
}
